export default "__VITE_ASSET__CmZS1Bp5__"